;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('SageDotCom/Components/ScoreFixes/YoutubeVideo',["score_bootstrap/Components/YoutubeVideo", "youtube_api"], factory) :
        typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("score_bootstrap/Components/YoutubeVideo"), require("youtube_api")) :
    console && console.error('YoutubeVideo component cannot be loaded into global namespace');
}(this/* window */, function (ytComponent, ytApi) {

    function YoutubeVideo() {
        // call the inherited const
        ytComponent.apply(this, arguments);
    }

    YoutubeVideo.prototype = Object.create(ytComponent.prototype);

    YoutubeVideo.init = function init(args) {
        if (ytApi && "error_sage_fallback" in ytApi) {
            console && console.info && console.info('YoutubeVideo component could not load youtube api');
            return null;
        }

        if (args.IsEditorEditing) return null;

        var video = new YoutubeVideo(args.scope,
            args.StateChangeMessagesTransmitting || [],
            args.PlayActionMessages || [],
            args.PauseActionMessages || []);
        return video;
    };



    return YoutubeVideo;
}));
